import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ClarityModule } from '@clr/angular';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { LoginService } from './login.service';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [CommonModule, LoginRoutingModule, FormsModule, ClarityModule, MatIconModule,LoginComponent],
  providers: [LoginService],
})
export class LoginModule {}
